enum EventStatus {
  Open = "O",
  Close = "C",
  Cancel = "X",
}

enum ParticapantStatus {
  Open = "O",
  Close = "C",
  None = "X",
  All = "A",
}

enum ResponseStatus {
  Agree = "Y",
  Deny = "N",
}

enum IsResolution {
  Done = "Y",
  NotYet = "N",
}

enum HasReply {
  Yes = "Y",
  No = "N",
}

enum Permision {
  ModifyEvent = "1",
  InvitePerson = "2",
  LookInvitationList = "3",
}

enum EventType {
  Paticipation = "1",
  Record = "3",
}




export {
  EventStatus,
  ParticapantStatus,
  ResponseStatus,
  IsResolution,
  HasReply,
  Permision,
  EventType,

};
